import React from "react";
import IconGallery from "../../../../../ui/iconGallery/IconGallery";

const GeneralIconsTab = ({ icons, selectedUrl, onSelect }) => {
    return (
        <IconGallery icons={icons} selectedUrl={selectedUrl} onSelect={onSelect} />
    );
};

export default GeneralIconsTab;
